(function () {
  document.addEventListener("DOMContentLoaded", function () {
    class AnnouncementBar {
      constructor(selector, headerSelector) {
        this.bar = document.querySelector(selector);
        this.closeBtn = this.bar?.querySelector(".close-btn");
        this.header = document.querySelector(headerSelector);
        this.isClosed = false;

        if (this.closeBtn) {
          this.closeBtn.addEventListener("click", () => this.close());
        }

        // Watch scroll position
        window.addEventListener("scroll", () => this.onScroll());
      }

      close() {
        if (this.bar) {
          this.bar.classList.add("hidden");
          this.bar.style.display = "none";
        }
        if (this.header) {
          this.header.style.top = "20px"; // move header back up
        }
        this.isClosed = true;
      }

      show() {
        if (this.bar) {
          this.bar.classList.remove("hidden");
          this.bar.style.display = "block";
        }
        if (this.header) {
          this.header.style.top = "60px"; // shift header down
        }
        this.isClosed = false;
      }

      onScroll() {
        // If user is at very top AND bar was closed → show it again
        if (window.scrollY === 0 && this.isClosed) {
          this.show();
        }
      }
    }

    // Initialize globally inside IIFE
    new AnnouncementBar(".ext-announcement-bar", "#shopify-section-header");
  });
})();